import produce from 'immer';

import { createKeyNotInTransform } from 'Lib/persist/transforms';
import type { Action } from 'Lib/reduxType';

import {
  LOCATION_PERMISSION_DENIED,
  LOCATION_PERMISSION_DISMISS,
  LOCATION_PERMISSION_GRANTED,
  LOCATION_TIMEOUT,
  LOCATION_TIMESTAMP_UPDATE,
  LOCATION_UPDATE,
} from './constants';
import initialState from './initialState';
import type { LocationState } from './types';

export const reducer = produce<LocationState, [Action]>((draft, action) => {
  switch (action.type) {
    case LOCATION_UPDATE:
      draft.denied = false;
      draft.timeout = false;
      draft.position = action.payload;
      break;
    case LOCATION_PERMISSION_DENIED:
      draft.denied = true;
      draft.position = null;
      break;
    case LOCATION_TIMEOUT:
      draft.timeout = true;
      break;
    case LOCATION_TIMESTAMP_UPDATE:
      if (draft.position) {
        draft.position.timestamp = action.payload;
        draft.denied = false;
        draft.timeout = false;
      }
      break;
    case LOCATION_PERMISSION_GRANTED:
      draft.denied = false;
      break;
    case LOCATION_PERMISSION_DISMISS:
      draft.dismissed = true;
      break;
  }
}, initialState);

export const persistConfig = {
  transforms: [createKeyNotInTransform(['denied', 'timeout'])],
  version: 1.0,
};
